import { BarChart3, CalendarCheck, CalendarClock, ClipboardCheck, FileClock, HandCoins, IdCard, LayoutDashboard, Settings, UserRound, UsersRound, WalletCards, type LucideIcon } from 'lucide-react';
import type { Role } from './AuthContext';
export type NavItem={label:string;to:string;icon:LucideIcon;roles?:Role[]};
const managerRoles: Role[] = ['branch_head', 'region_head', 'general_head', 'hr', 'admin'];
export const nav:NavItem[]=[
  {label:'Home',to:'/',icon:LayoutDashboard},
  {label:'Attendance',to:'/attendance',icon:CalendarCheck},
  {label:'Team Status',to:'/team',icon:UsersRound,roles:managerRoles},
  {label:'Leave',to:'/leave',icon:WalletCards},
  {label:'Tasks',to:'/tasks',icon:ClipboardCheck},
  {label:'Staff',to:'/staff',icon:IdCard,roles:managerRoles},
  {label:'Loans',to:'/loans',icon:HandCoins,roles:['staff','hr','admin']},
  {label:'Salary',to:'/salary',icon:WalletCards,roles:['hr','admin']},
  {label:'Payroll',to:'/payroll',icon:CalendarClock,roles:['hr','admin']},
  {label:'Reports',to:'/reports',icon:BarChart3,roles:managerRoles},
  {label:'Audit log',to:'/audit-log',icon:FileClock,roles:['admin']},
  {label:'My Profile',to:'/profile',icon:UserRound},
  {label:'My Payslips',to:'/my-payslips',icon:WalletCards},
  {label:'Settings',to:'/settings',icon:Settings,roles:['hr','admin']},
];
export const visibleNav=(roles:Role[])=>nav.filter((item)=>!item.roles||item.roles.some((role)=>roles.includes(role)));
